import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "notificationIcon",
})
export class NotificationIconPipe implements PipeTransform {
  transform(value: string, isTooltip: boolean = false): string {
    let result = value;
    result = NotificationIconName[result] ?? result;
    if(value) {
      if(isTooltip) {
        result = NotificationIconTooltip[result] == undefined ? result : NotificationIconTooltip[result];
      } else {
        result = NotificationIconStatus[result] == undefined ? result : NotificationIconStatus[result];        
      }
    }
    return result;
  }
}

export enum NotificationIconClass {
  COMMENT = "icon-comment",
  SUBMITTED = "icon-submitted",
  REWORK = "icon-rework",
  COMPLETE = "icon-complete",
  ICON_COMMENT = "comment",
  ICON_SUBMITTED = "submitted",
  ICON_REWORK = "moreWork",
  ICON_COMPLETE = "accepted"
};

export class NotificationIconTooltipMessage {
  static readonly COMMENT = $localize`:@@comment-to-read:There's a comment for you to read`;
  static readonly REWORK = $localize`:@@status-rework:Try again(needs work)`;
  static readonly COMPLETE = $localize`:@@status-complete:Complete(accepted)`;
  static readonly SUBMITTED = $localize`:@@status-submitted:Submitted(ready for marking)`;;
};

export const NotificationIconStatus = {
  comment: NotificationIconClass.COMMENT,
  submitted: NotificationIconClass.SUBMITTED,
  accepted: NotificationIconClass.COMPLETE,
  moreWork: NotificationIconClass.REWORK
};

export const NotificationIconName = {
  [NotificationIconClass.COMMENT] : NotificationIconClass.ICON_COMMENT,
  [NotificationIconClass.SUBMITTED] : NotificationIconClass.ICON_SUBMITTED,
  [NotificationIconClass.REWORK] : NotificationIconClass.ICON_REWORK,
  [NotificationIconClass.COMPLETE] : NotificationIconClass.ICON_COMPLETE
}

export const NotificationIconTooltip = {
  comment: NotificationIconTooltipMessage.COMMENT,
  submitted: NotificationIconTooltipMessage.SUBMITTED,
  accepted: NotificationIconTooltipMessage.COMPLETE,
  complete: NotificationIconTooltipMessage.COMPLETE,
  rework: NotificationIconTooltipMessage.REWORK,
  moreWork: NotificationIconTooltipMessage.REWORK
}

